import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/hooks/store/useAuth";

export const useIsUnverified = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();

  useEffect(() => {
    switch (authState) {
      case "unverified":
        break;
      case "authenticated":
        navigate("/");
        break;
      default:
        navigate("/login");
        break;
    }
  }, [navigate, authState]);
};
